import { h } from "preact";
import { withWidgetConfiguration } from "../../../node_modules/@sgwt-widget/core";
import { PieChartOpt } from "../../common/components/PieChartOpt";
import { CheckReponseDataForError } from "../../common/generic/generic-helper";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { SalesCreditBvRetetionHelper } from "../../common/salescredit/salescredit-bv-retention-helper";
import { IProps } from "../../common/salescredit/salescredit-types";
import { mapData } from "../../common/utils/AirPnlRetentionRate/AirPnlHelper";
import { ISalesCreditRetentionEquivType } from "../../common/utils/AirPnlRetentionRate/AirPnlTypes";
import { BuildPie } from "../utils/helper";
import { getCommonPptExport } from "../../common/export/chart-helper";

interface IState {
  email: string;
  options: any;
  bvEquiv: number;
  retentionEquiv: string;
}

export class SalesCreditRetentionRateClass extends SalesCreditBvRetetionHelper<
  IState
> {
  public constructor() {
    super();
    this.setState({
      bvEquiv: 0,
      options: undefined,
      retentionEquiv: "",
    });
  }

  public getPptExport() {
    return getCommonPptExport(
      "pie",
      this.state.options,
      data => data.pclabel,
      true
    );
  }

  protected shouldFetchApiData(nextProps: IProps): boolean {
    return true;
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <div
        id="container"
        style="width: 100%; height: 90%; boxSizing: border-box"
      >
        <div style="Row">
          <div>
            <b>BV adjust: </b>
            {this.state.bvEquiv.toLocaleString("en") + " K€"}
          </div>
          <div>
            <b>Retention adjust: </b>
            {this.state.retentionEquiv}
          </div>
        </div>
        <PieChartOpt options={this.state.options} />
      </div>
    );
  }

  protected ProcessData(responseData: IGenericAggregateResponse) {
    const errorStatusForSC = CheckReponseDataForError(responseData);

    const error = errorStatusForSC;
    if (error) {
      this.setDataStatus(error === undefined ? "no-data" : error);
      this.setStatusText(responseData.statusText);
      this.setState({
        bvEquiv: 0,
        options: undefined,
        retentionEquiv: "",
      });
      return;
    }
    const result: ISalesCreditRetentionEquivType = mapData(responseData);
    const pieOptions = BuildPie(result.SalesCreditList);
    if (result !== undefined && result.SalesCreditList !== undefined) {
      if (result.SalesCreditList.length !== 0) {
        this.setState({
          bvEquiv: result.BVEquiv,
          options: pieOptions,
          retentionEquiv: result.RetentionEquiv,
        });
        this.setDataStatus("ready");
      }
    } else {
      this.setState({
        bvEquiv: 0,
        options: undefined,
        retentionEquiv: "",
      });
      this.setDataStatus("no-data");
    }
  }
}
export const SalesCreditRetentionRate = withWidgetConfiguration(
  SalesCreditRetentionRateClass
);
